import { BoardFragmentFragment } from '@apps/www/src/__generated__/graphql';
import SVDropdownContent from '@pkgs/shared-client/components/SVDropdownContent';
import SVTooltip from '@pkgs/shared-client/components/SVTooltip';
import config from '@pkgs/shared-client/config';
import useEventCallback from '@pkgs/shared-client/hooks/useEventCallback';
import formatURL from '@pkgs/shared/helpers/formatURL';
import ctc from 'copy-to-clipboard';
import { useRef } from 'react';
import SVWithTooltipErrorBoundary, {
	type Props as SVWithTooltipErrorBoundaryProps,
} from './SVWithTooltipErrorBoundary';

const _SVShareBoardContainer = (
	{ board }: { board: BoardFragmentFragment },
	{ showTooltipError }: SVWithTooltipErrorBoundaryProps,
) => {
	const elementRef = useRef<HTMLSpanElement | null>(null);

	const handleClick = useEventCallback(() => {
		const boardURL = board.url;

		if (boardURL) {
			ctc(formatURL(config.baseURL, boardURL));

			if (elementRef.current) {
				SVTooltip.show(elementRef.current, 'Link copied.');
			}
		}
	});

	return (
		<SVDropdownContent.Links.ItemPreventClose onClick={handleClick}>
			<span ref={elementRef}>Share</span>
		</SVDropdownContent.Links.ItemPreventClose>
	);
};

const SVShareBoardContainer = SVWithTooltipErrorBoundary(_SVShareBoardContainer);

export default SVShareBoardContainer;
